import React from 'react';
import GenericFinder from './finders';
import styles from './App.module.css';
export const App = _ref => {
  let {} = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.AppContainer
  }, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(GenericFinder, null)));
};
export default App;
/**
 * This is necessary because if liferay portlet fails the thing displayed in the page editor
 * is 0px tall and you cannot click the menu in the portlet's top right corner to change a
 * configuration option (and presumably configure it so it doesn't fail)
 * 
 * There currently is no way to create an error boundary with hook (although there are npm packages for it)
 * because there is no hooks equivalent of `getDerivedStateFromError()`. A class component it is!
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, info) {
    console.error({
      error,
      errorInfo: info
    });
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.ErrorBoundary
      }, /*#__PURE__*/React.createElement("span", null, "An Error Has Occurred"));
    } else {
      return this.props.children;
    }
  }
}